import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { useAuth } from "@/hooks/use-auth";

export default function AuthLayout() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate()

  // useEffect(() => {
  //   if (isAuthenticated.loaded && isAuthenticated.status)
  //     navigate("/", { replace: true, viewTransition: true });
  // }, [isAuthenticated]);

  return <Outlet />;
}
